import React, { Component } from "react";
import RcTooltip from "rc-tooltip";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { LINK } from "@/utils/getting";
import { ScriptCallback } from "@/utils/setting";
import Store from "@/stores";

class PowerTips extends Component {
	static propTypes = {
		id: PropTypes.string,
		tooltipParams: PropTypes.string
	}
	static defaultProps = {
		id: "",
		tooltipParams: ""
	}
	state = {
		content: "",
		status: "载入中..."
	}
	componentDidMount() {
		const { id, tooltipParams } = this.props;
		ScriptCallback({
			error: () => this.setState({ status: "系统繁忙，请稍后再试..." }),
			success: () => {
				const val = sessionStorage.getItem(tooltipParams);
				if (val) {
					this.setState({
						content: JSON.parse(val),
						status: ""
					});
				} else {
					if (window.d3_data) {
						sessionStorage.setItem(tooltipParams, JSON.stringify(window.d3_data));
						this.setState({
							content: window.d3_data,
							status: ""
						});
					} else {
						this.setState({ status: "系统繁忙，请稍后再试..." });
					}
				}
			},
			url: `${LINK.power}${tooltipParams.replace("-" + id, "")}.js`
		});
	}
	componentWillUnmount() {
		this.setState = () => {};
	}
	render() {
		const { content, status } = this.state;
		if (status) return <p className="tips">{status}</p>;
		if (!content) return null;
		return <div dangerouslySetInnerHTML={{ __html: content }} />;
	}
}

@observer
class Power extends Component {
	render() {
		const { legendaryPowers } = Store._ladderStore.hero;
		const weapon = legendaryPowers[0]
			? (
				<RcTooltip
					destroyTooltipOnHide={true}
					overlay={<PowerTips {...legendaryPowers[0]} />}
					overlayClassName="ladder-power-tips"
					placement="rightTop"
				>
					<div>
						<img className="abs-ct" src={`${LINK.equip}/${legendaryPowers[0].icon}.png`} />
					</div>
				</RcTooltip>
			)
			: null;
		const armor = legendaryPowers[1]
			? (
				<RcTooltip
					destroyTooltipOnHide={true}
					overlay={<PowerTips {...legendaryPowers[1]} />}
					overlayClassName="ladder-power-tips"
					placement="rightTop"
				>
					<div>
						<img className="abs-ct" src={`${LINK.equip}/${legendaryPowers[1].icon}.png`} />
					</div>
				</RcTooltip>
			)
			: null;
		const jewelry = legendaryPowers[2]
			? (
				<RcTooltip
					destroyTooltipOnHide={true}
					overlay={<PowerTips {...legendaryPowers[2]} />}
					overlayClassName="ladder-power-tips"
					placement="rightTop"
				>
					<div>
						<img className="abs-ct" src={`${LINK.equip}/${legendaryPowers[2].icon}.png`} />
					</div>
				</RcTooltip>
			)
			: null;
		return (
			<div className="ladder-power">
				<h3>卡奈魔盒传奇力量</h3>
				<ul>
					<li key={1} className="weapon">
						{weapon}
						<p>武器</p>
					</li>
					<li key={2} className="armor">
						{armor}
						<p>防具</p>
					</li>
					<li key={3} className="jewelry">
						{jewelry}
						<p>首饰</p>
					</li>
				</ul>
			</div>
		);
	}
}
export default Power;